import { Style, Icon, Text, Fill, Stroke } from 'ol/style';

let nav_point_style_text = new Style({
    text: new Text({
        font: 'bold 20px sans-serif',
        fill: new Fill({ color: 'rgb(0,0,255)' }),
        //stroke: new Stroke({ color: 'rgb(255,0,0)', width: 1 }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        justify: "center",
    }),
});

function nav_point_style_fun(feature)
{
    let nav_pointdo = feature.get("nav_pointdo");
    let name = nav_pointdo.name;
    let text_style = nav_point_style_text.clone();

    text_style.getText().setText(name);

    return text_style;
}

export { nav_point_style_fun };